module.exports = __webpack_public_path__ + "img/recruitment.47ed4507.jpg";